import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_proxy = (
  id,
  proxyHost,
  proxyPort,
  proxyUsername,
  proxyPassword,
  proxyType,
  updateTime,
  status
) => {
  return api.post(`${ApiEndpointConstants.MODIFYPROXY}`, {
    id,
    proxyHost,
    proxyPort,
    proxyUsername,
    proxyPassword,
    proxyType,
    updateTime,
    status,
  });
};
